<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">选择指定学员和课程进行导出</b>        
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 选择学员</b>        
      </el-row>

      <el-row class="mt-2 mb-5">
        <PersonSelect @onValueChanged="onPersonValChanged"></PersonSelect>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          class="mt-1"
          v-model="personsJson">
        </el-input>
        <el-button class="mt-1" @click="confirmUid" :loading="loading">确认</el-button>
      </el-row>

      <el-row>
        <b class="font_base">已选择的学员：</b>                
      </el-row>

      <el-row class="select_user_row">
        <template v-for="(item,index) in selectUsers">
          <el-row class="mt-1" :key="item.label">              
            <el-col :span="12">
                <p class="p3">{{item.label}}</p>
            </el-col>
            <el-col :span="3">
                <p class="p3 mt-0">{{item.value}}</p>
            </el-col>
            <el-col :span="3">
              <el-link type="warning" @click="onRemoveSelectUser(index)">移除</el-link>
            </el-col>
          </el-row>  
        </template>      
      </el-row>

      <el-row class="mt-2">
          <b class="font_base">2. 选择排课信息</b>        
      </el-row>

      <el-row class="mt-2">
        <SchedulingSelect @onValueChanged="onSchedulingValChanged"></SchedulingSelect>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          class="mt-1"
          v-model="scheduleJson">
        </el-input>
        <el-button class="mt-1" @click="confirmSid" :loading="loading">确认</el-button>
      </el-row>

      <el-row>
        <b class="font_base">已选择的排课信息：</b>                
      </el-row>

      <el-row class="select_user_row">
        <template v-for="(item,index) in selectSchedulings">
          <el-row class="mt-1">              
            <el-col :span="12">
                <p class="p3">{{item.title}}</p>
            </el-col>
            <el-col :span="3">
                <p class="p3 mt-0">{{item.id}}</p>
            </el-col>
            <el-col :span="3">
              <el-link type="warning" @click="onRemoveSelectScheduling(index)">移除</el-link>
            </el-col>
          </el-row>  
        </template>      
      </el-row>

      <el-row class="mt-2">
          <b class="font_base">3. 选择是否退休</b>        
      </el-row>
      <el-row class="mt-2">
        <el-checkbox v-model="retired">是否退休</el-checkbox>
      </el-row>


      <el-row class="mt-2">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="jsondata">
        </el-input>
      </el-row>

      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">导出</el-button>
      </el-row>
  </div>
</template>

<script>
import { PersonSelect,SchedulingSelect } from "@/views/components/select"
import { exportApi,importUidsApi,importSidsApi } from "@/api/module/export/export"

export default {

  name : 'ExportUserAndScheduling',

  components:{
    PersonSelect,SchedulingSelect
  },

  data(){
    return {
      loading : false,
      selectUsers : [],
      personsJson : "",
      scheduleJson : "",
      selectSchedulings:[],
      jsondata : null,
      retired : false

    }
  },
  methods:{
    init(){
    },

    onPersonValChanged(val,item){
      this.selectUsers.push(item);
    },

    onSchedulingValChanged(val,item){
      this.selectSchedulings.push(item);
    },

    onRemoveSelectUser(index){
      this.selectUsers.splice(index,1)
    },

    onRemoveSelectScheduling(index){
      this.selectSchedulings.splice(index,1)

    },

    onPersonChanged(val){

    },

    publish(){

      let jsondata = this.jsondata;

      if(this.loading){
        return;
      }
      
      let uids = new Array();
      for(let i = 0; i < this.selectUsers.length; i++){
        uids.push(this.selectUsers[i].value);
      }

      let sids = new Array();
      for(let i = 0; i < this.selectSchedulings.length; i++){
        sids.push(this.selectSchedulings[i].id);
      }

      // if(uids.length == 0 && !jsondata){
      //   this.$message.error("需选择学员！");
      //   return;
      // }

      // if(sids.length == 0 && !jsondata){
      //   this.$message.error("需选择排课！");
      //   return;
      // }



      this.loading = true;


      let url = "/api/manager/export/userandsches"

      let data;

      if(jsondata){
        data = JSON.parse(jsondata);
      }
      else {
        data = {
          uids : uids,
          sids: sids,
          retired : this.retired
        }
      }


      exportApi(data,url)
        .then((res)=>{
            if(res.data.size > 0){
              let filename = "data.xls";
              let data = res.data;

              console.log("res.data",data.length)

              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click()    
            }
            else {
              this.$message.error("导出错误");
            }
        })
        .finally(()=>{
          this.loading = false;
        })

    },

    confirmUid(){

      if(!this.personsJson){
        return;
      }

      let pj = JSON.parse(this.personsJson);

      importUidsApi(pj)
        .then((r)=>{
          console.log("personsJson",r)
          for(let i = 0; i < r.length; i++){
            let item = {
              label : r[i].name + " - " + r[i].unitTitle,
              value : r[i].id,
              id : r[i].id
            }

            this.selectUsers.push(item);
          }
        })
    },

    confirmSid(){
      if(!this.scheduleJson){
        return;
      }

      let pj = JSON.parse(this.scheduleJson);

      importSidsApi(pj)
        .then((r)=>{
          console.log("scheduleJson",r)
          // for(let i = 0; i < r.length; i++){
          //   let item = {
          //     label : r[i].name + " - " + r[i].unitTitle,
          //     value : r[i].id,
          //     id : r[i].id
          //   }

          //   this.selectUsers.push(item);
          // }
        }) 
    }
  },

  mounted(){

  },

  created() {

  }



}
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.select_user_row{
  margin-top: 0px;
  margin-bottom: 0px;

  max-height: 300px;
  overflow-y: auto;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
</style>